import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PlanProvider } from "@/context/PlanContext";
import Navbar from "@/components/Navbar";
import MobileTabBar from "@/components/MobileTabBar";
import AuthModal from "@/components/AuthModal";
import AuthCallback from "@/components/AuthCallback";
import Scanner from "@/pages/Scanner";
import Journal from "@/pages/Journal";
import Stats from "@/pages/Stats";
import Portfolio from "@/pages/Portfolio";
import Watchlist from "@/pages/Watchlist";
import CatalystCalendar from "@/pages/CatalystCalendar";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminCodes from "@/pages/AdminCodes";
import AdminTeam from "@/pages/AdminTeam";
import Account from "@/pages/Account";
import Legal from "@/pages/Legal";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <AuthModal />
      <MobileTabBar />
      <main className="page-with-tabs">
      <Routes>
        <Route path="/" element={<Scanner />} />
        <Route path="/scanner" element={<Scanner />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/watchlist" element={<Watchlist />} />
        <Route path="/catalysts" element={<CatalystCalendar />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<Pricing />} />
        <Route path="/admin/codes" element={<AdminCodes />} />
        <Route path="/admin/team" element={<AdminTeam />} />
        <Route path="/account" element={<Account />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="*" element={<Scanner />} />
      </Routes>
      <footer className="hidden md:flex max-w-7xl mx-auto px-4 sm:px-8 py-6 items-center justify-between text-[11px] font-mono text-slate-600" data-testid="site-footer">
        <span>© {new Date().getFullYear()} CatalystCaddy · Research tool, not financial advice. Memecoins can go to zero.</span>
        <span className="flex gap-4">
          <Link to="/legal#disclaimer" className="hover:text-slate-300">Disclaimer</Link>
          <Link to="/legal#terms" className="hover:text-slate-300">Terms</Link>
          <Link to="/legal#privacy" className="hover:text-slate-300">Privacy</Link>
        </span>
      </footer>
      </main>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider><PlanProvider>
          <AppRouter />
          <Toaster position="top-center" theme="dark" richColors />
        </PlanProvider></AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
